import * as React from 'react'
import { CmsLandingPageComponent, CmsLandingPageLayout } from './types'
import NavigationSection, {
  NavigationSectionProps,
} from './NavigationSection/NavigationSection'
import ProductCarousel, {
  ProductCarouselProps,
} from './ProductCarousel/ProductCarousel'
import HeroBannerBreakpointHOC from './HeroBannerBreakpointHOC/HeroBannerBreakpointHOC'
import css from './CmsLandingPage.scss'
import FeatureSection from './FeatureSection'
import { FeatureSectionProps } from './FeatureSection/FeatureSection'

type ComponentProps =
  | NavigationSectionProps
  | ProductCarouselProps
  | FeatureSectionProps

interface CmsLandingPageProps {
  cmsLandingPageLayout: CmsLandingPageLayout
  _componentMap: Map<string, React.ComponentType<ComponentProps>>
}

const defaultComponentMap = new Map([
  [
    'shopLandingPageNavigationSection',
    NavigationSection as React.ComponentType<ComponentProps>,
  ],
  [
    'shopLandingPageProductCarousel',
    ProductCarousel as React.ComponentType<ComponentProps>,
  ],
  [
    'shopLandingPageFeatureSection',
    FeatureSection as React.ComponentType<ComponentProps>,
  ],
])

const getProps = ({ contentType, ...rest }: CmsLandingPageComponent) => rest

const CmsLandingPage = ({
  cmsLandingPageLayout,
  _componentMap = defaultComponentMap,
}: CmsLandingPageProps) => {
  const { components } = cmsLandingPageLayout
  const heroComponents = components?.filter(
    (c) => c.contentType === 'shopLandingPageHeroBanner'
  )
  const nonHeroComponents = components?.filter(
    (c) => c.contentType !== 'shopLandingPageHeroBanner'
  )

  /*
   slot positions are indexed starting at 1 (top) and increase as you move down on the page
   since the array indices in the map method start at 0, we need to add 2 to account
   for the natural offset
  */
  return (
    <div
      className={css.landingPageContainer}
      data-testid="landingPageContainer"
    >
      <HeroBannerBreakpointHOC components={heroComponents} />
      {nonHeroComponents &&
        nonHeroComponents.map((cmsComponent, index) => {
          const Component = _componentMap.get(cmsComponent.contentType)
          const props = getProps(cmsComponent)
          return (
            Component && (
              <Component
                key={cmsComponent.contentfulId}
                slot={index + 2}
                {...props}
              />
            )
          )
        })}
    </div>
  )
}

export default CmsLandingPage
